import { useMutation } from '@tanstack/vue-query';
import { computed } from 'vue';
import apiService from '@services/base/apiService';

interface Params {
  urlScript: string;
  bestandsnaam: string;
}

function cleanUpHtmlChars(str: string): string {
  return str.replace(/&amp;/g, '&');
}

export function useClassicExportHtmlToExcel() {
  const mutation = useMutation({
    mutationFn: async ({ urlScript, bestandsnaam }: Params): Promise<void> => {
      const response = await apiService.apiClient.get<string>(urlScript, {
        timeout: 30 * 60 * 1000,
      });

      const cleanedHtml = cleanUpHtmlChars(response.data);

      const payload = new URLSearchParams();
      payload.append('data', cleanedHtml);
      payload.append('bestandsnaam', bestandsnaam);

      const postResponse = await apiService.apiClient.post(
        '/webservice/html2excel/',
        payload.toString(),
        {
          timeout: 5 * 60 * 1000,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );

      if (!postResponse.data?.gelukt) {
        throw new Error(`Export mislukt. Melding: ${postResponse.data?.melding}`);
      }

      const link = document.createElement('a');
      link.href = postResponse.data.locatieexcelbestand_relatief;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    retry: false,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    isPending: computed(() => mutation.isPending.value),
    error: computed(() => mutation.error.value),
  };
}
